import { createFileRoute } from "@tanstack/react-router";

import { TenantSecretDetailPage } from "../features/tenantSecrets/TenantSecretDetailPage";

export const Route = createFileRoute(
  "/accounts/$accountSlug/tenants/$tenantSlug/secrets/$secretId",
)({
  component: SecretDetailRoute,
});

function SecretDetailRoute() {
  const { accountSlug, tenantSlug, secretId } = Route.useParams();
  return (
    <TenantSecretDetailPage
      accountSlug={accountSlug}
      tenantSlug={tenantSlug}
      secretId={secretId}
    />
  );
}
